import { Injectable } from '@angular/core';
import { Force } from '../../models';
import { PDFConfig } from './pdf-config';

@Injectable({ providedIn: 'root' })
export class PDFService {
    generatePDF(force: Force, pdfConfig: PDFConfig) {}
}
